<template>
  <q-card flat bordered class="row justify-between">
    <div class="col-lg-12 col-12 q-mt-x">
      <div class="q-ma-sm text-center q-ml-md">
        <span class="text-subtitle1 text-secondary text-bold">
          <span v-if="weekly">Weekly Signal Status</span>

          <span v-else class="text-bold"> Daily Signal Status </span>
        </span>
      </div>
      <div class="q-mx-xs q-pa-xs-xs">
        <q-separator />
        <div v-if="!buysell">
          <p>No Signals Found</p>
        </div>
        <div v-else>
          <div v-if="buysell.buy_date && !buysell.sell_date">
            <q-list
              bordered
              separator
              class="text-subtitle2 q-pa-none q-ma-none"
            >
              <q-item>
                <q-item-section> Buy Range</q-item-section>

                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  {{ (0.99 * buysell.buy_price)?.toFixed(2) }} to
                  {{ buysell.buy_price?.toFixed(2) }}
                </q-item-section>
              </q-item>

              <q-item
                v-if="
                  buysell.weak_signal != null ||
                  buysell.strong_signal != null ||
                  buysell.very_strong_signal != null ||
                  buysell.medium_signal != null
                "
              >
                <q-item-section>
                  Strength

                  <!-- <q-item-label caption>Caption</q-item-label> -->
                </q-item-section>
                <q-separator vertical></q-separator>
                <q-item-section class="text-left q-ml-lg">
                  <q-item-label>
                    {{
                      buysell.weak_signal != null
                        ? "Weak"
                        : buysell.strong_signal != null
                        ? "Strong"
                        : buysell.very_strong_signal != null
                        ? "Very Strong"
                        : buysell.medium_signal != null
                        ? "Medium"
                        : ""
                    }}
                    <q-icon
                      :name="
                        buysell.weak_signal != null
                          ? 'battery_1_bar'
                          : buysell.strong_signal != null
                          ? 'battery_6_bar'
                          : buysell.very_strong_signal != null
                          ? 'battery_std'
                          : buysell.medium_signal != null
                          ? 'battery_4_bar'
                          : ''
                      "
                      class="rotate-90 q-ma-sm"
                      size="xs"
                      color="green"
                    />
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item>
                <q-item-section
                  :class="
                    marketPrice > buysell.profit_target ? 'q-mr-lg' : 'q-mr-md'
                  "
                >
                  <q-item-label> Profit Target</q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.profit_target?.toFixed(2) }}

                  <q-item-label
                    class="text-caption"
                    :style="{
                      color:
                        buysell.profit_target - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                  >
                    {{
                      (
                        ((buysell.profit_target - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}%
                    <q-icon
                      :name="
                        buysell.profit_target - buysell.buy_price > 0
                          ? 'north'
                          : 'south'
                      "
                    ></q-icon>
                  </q-item-label>
                </q-item-section>

                <q-item-section side>
                  <q-icon
                    v-if="marketPrice > buysell.profit_target"
                    class="text-green q-ml-none"
                    size="sm"
                    name="check_circle"
                  />
                </q-item-section>
              </q-item>

              <q-item v-if="buysell.profit_target1 != null">
                <q-item-section
                  :class="marketPrice > buysell.profit_target1 ? 'q-mr-lg' : ''"
                >
                  Profit Target 1
                  <q-item-label overline> </q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>
                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.profit_target1?.toFixed(2) }}
                </q-item-section>
                <q-icon
                  class="text-green q-ml-none"
                  size="sm"
                  v-if="marketPrice > buysell.profit_target1"
                  name="check_circle"
                />
              </q-item>

              <q-item v-if="buysell.profit_target2 != null">
                <q-item-section
                  :class="marketPrice > buysell.profit_target2 ? 'q-mr-lg' : ''"
                >
                  Profit Target 2
                  <q-item-label overline> </q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>
                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.profit_target2?.toFixed(2) }}
                </q-item-section>
                <q-icon
                  class="text-green q-ml-none"
                  size="sm"
                  v-if="marketPrice > buysell.profit_target2"
                  name="check_circle"
                />
              </q-item>

              <q-item>
                <q-item-section
                  :class="marketPrice < buysell.stop_loss ? 'q-mr-lg' : ''"
                >
                  <q-item-label> Stop Loss </q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.stop_loss?.toFixed(2) }}

                  <q-item-label
                    class="text-caption"
                    :style="{
                      color:
                        buysell.stop_loss - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >{{
                      (
                        ((buysell.stop_loss - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}%
                    <q-icon
                      :name="
                        buysell.stop_loss - buysell.buy_price > 0
                          ? 'north'
                          : 'south'
                      "
                    />
                  </q-item-label>
                </q-item-section>

                <q-icon
                  v-if="marketPrice < buysell?.stop_loss"
                  class="text-red q-ml-none"
                  size="sm"
                  name="check_circle"
                />
              </q-item>

              <q-item>
                <q-item-section class="">
                  <q-item-label>
                    Risk/Reward
                    <span class="text-caption text-bold text-grey-9">
                      Ratio
                    </span>
                  </q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  1 :
                  {{
                    (
                      (buysell.profit_target - buysell.buy_price) /
                      (buysell.buy_price - buysell.stop_loss)
                    )?.toFixed(2)
                  }}
                </q-item-section>
              </q-item>

              <q-item>
                <q-item-section>
                  Trailing Stop Loss
                  <q-item-label overline> </q-item-label>
                </q-item-section>
                <q-separator vertical></q-separator>
                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.trailing_stop_loss?.toFixed(2) }}
                  <q-item-label
                    class="text-caption"
                    :style="{
                      color:
                        buysell.trailing_stop_loss - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >{{
                      (
                        ((buysell.trailing_stop_loss - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}%
                    <q-icon
                      :name="
                        buysell.trailing_stop_loss - buysell.buy_price > 0
                          ? 'north'
                          : 'south'
                      "
                    ></q-icon>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>

            <q-list bordered separator class="text-subtitle2 q-mt-md" dense>
              <q-item>
                <q-item-section class=""> Market Price </q-item-section>
                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  <q-item-label>
                    {{ marketPrice }}

                    <span
                      class="q-pl-xs text-body2"
                      :style="{
                        color: closePriceDiff > 0 ? 'green' : 'red',
                      }"
                    >
                      ({{ closePriceDiff?.toFixed(2) }})</span
                    >
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class=""> Waiting for </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section class="text-left q-ml-lg"
                  ><span class="text-red text-bold"> Red Signal </span>
                  <span class="text-primary text-caption text-bold"
                    >(Hold state)</span
                  >
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class="">
                  <span>
                    Last
                    <span class="text-green"> Green Signal</span>
                  </span>
                  <span class="text-body2 text-bold text-grey-8">
                    Generated at
                  </span>
                </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section class="text-left q-ml-lg">
                  <q-item-label>
                    <span>{{ buysell.buy_date }}</span> @
                    <span class="text-primary">
                      {{ buysell.buy_price?.toFixed(2) }}</span
                    >
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class="">
                  <span> LTP Change from </span>
                  <span class="text-body2 text-bold text-grey-8">
                    last signal
                  </span>
                </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section
                  class="text-left q-ml-lg"
                  :style="{
                    color:
                      marketPrice - buysell.buy_price > 0 ? 'green' : 'red',
                  }"
                >
                  {{ (marketPrice - buysell.buy_price).toFixed(2) }}

                  <q-item-label class="text-caption">
                    {{
                      (
                        ((marketPrice - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      ).toFixed(2)
                    }}
                    %
                    <q-icon
                      :name="
                        marketPrice - buysell.buy_price > 0 ? 'north' : 'south'
                      "
                    ></q-icon>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>

            <q-separator />
          </div>

          <div v-else-if="buysell.buy_date && buysell.sell_date">
            <q-list bordered separator class="text-bold" dense>
              <q-item>
                <q-item-section> Sell Target Range </q-item-section>
                <q-separator vertical />
                <q-item-section class="text-left q-ml-lg">
                  {{ buysell.sell_price }} to
                  {{ (1.02 * buysell.sell_price)?.toFixed(2) }}
                </q-item-section>
              </q-item>
            </q-list>

            <q-list bordered separator class="text-bold q-mt-md" dense>
              <q-item>
                <q-item-section class=""> Market Price </q-item-section>
                <q-separator vertical></q-separator>

                <q-item-section class="text-left q-ml-lg">
                  <q-item-label>
                    {{ marketPrice }}

                    <span
                      class="q-pl-xs text-body2"
                      :style="{
                        color: closePriceDiff > 0 ? 'green' : 'red',
                      }"
                    >
                      ({{ closePriceDiff?.toFixed(2) }})</span
                    >
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item>
                <q-item-section class=""> Waiting for </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section class="text-left q-ml-lg"
                  ><span class="text-green text-bol"> Green Signal </span>
                  <span class="text-primary text-caption text-bold"
                    >(No Setup)</span
                  >
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class="">
                  <span>
                    Last
                    <span class="text-red"> Red Signal</span>
                  </span>
                  <span class="text-body2 text-bold text-grey-8">
                    Generated at
                  </span>
                </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section class="text-left q-ml-lg">
                  <q-item-label>
                    <span>{{ buysell.sell_date }}</span> @
                    <span class="text-primary"> {{ buysell.sell_price }}</span>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class="">
                  <span> LTP Change from </span>
                  <span class="text-body2 text-bold text-grey-8">
                    last signal
                  </span>
                </q-item-section>
                <q-separator vertical> </q-separator>

                <q-item-section
                  class="text-left q-ml-lg"
                  :style="{
                    color:
                      marketPrice - buysell.sell_price > 0 ? 'green' : 'red',
                  }"
                >
                  {{ (marketPrice - buysell.sell_price).toFixed(2) }}

                  <q-item-label class="text-caption">
                    {{
                      (
                        ((marketPrice - buysell.sell_price) /
                          buysell.sell_price) *
                        100
                      ).toFixed(2)
                    }}
                    %
                    <q-icon
                      :name="
                        marketPrice - buysell.sell_price > 0 ? 'north' : 'south'
                      "
                    ></q-icon>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </div>

        <div v-if="buyTarget || sellTarget">
          <q-separator class="q-mb-md" />
          <div class="text-body2 text-secondary text-bold">
            Your Buy Sell Target
          </div>
          <q-separator class="q-my-sm" />
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="row">
                <p>Buy Target</p>
                <p v-if="buyTarget" class="q-ml-auto q-mr-md">
                  {{ buyTarget }}
                </p>
                <p v-else class="q-ml-auto q-mr-md">-</p>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="row">
                <p>Sell Target</p>
                <p v-if="sellTarget" class="q-ml-auto q-mr-md">
                  {{ sellTarget }}
                </p>
                <p v-else class="q-ml-auto q-mr-md">-</p>
              </div>
            </div>
          </div>
        </div>
        <StockwiseKeyValueComponents :symbol="symbol" />
      </div>
    </div>
    <q-separator class="q-my-md" />
  </q-card>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import useData from "src/use/data";
import useMembership from "src/use/membership";
import StockwiseKeyValueComponents from "src/components/PriceActionSignals/StockwiseKeyValueComponents.vue";

export default {
  name: "StockWiseSignalStatus",
  emits: ["buysellData"],
  components: {
    StockwiseKeyValueComponents,
  },
  props: {
    symbol: {
      type: String,
      required: true,
    },
    weekly: {
      type: Boolean,
      default: false,
    },
    intraday: {
      type: Boolean,
      default: false,
    },
    daily: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const {
      historyDataSearch,
      buySellSearch,
      buySellSearchWeekly,
      trailingStopLossBuySell,
    } = useData();

    const { getMySignalswithTarget } = useMembership();

    const buysell = ref([]);
    const marketPrice = ref([]);
    const closePriceDiff = ref(null);
    const signalsWithTarget = ref([]);
    const buyTarget = ref(null);
    const sellTarget = ref(null);

    const getSignal = async (searchText) => {
      if(!searchText){
        return
      }
      try {
        signalsWithTarget.value = (await getMySignalswithTarget()).data;
        buyTarget.value = getTarget(signalsWithTarget.value, searchText, "buy");
        sellTarget.value = getTarget(
          signalsWithTarget.value,
          searchText,
          "sell"
        );

        let buySellResponse;
        if (props.daily) {
          buySellResponse = await buySellSearch(props.symbol);
        } else if (props.weekly) {
          buySellResponse = await buySellSearchWeekly(props.symbol);
        } else if (props.intraday) {
        }

        buysell.value = buySellResponse.data[0];

        const trailingStopLossResponse = await trailingStopLossBuySell(
          props.symbol
        );

        if (trailingStopLossResponse.data.length) {
          buysell.value["trailing_stop_loss"] =
            trailingStopLossResponse.data[0].trailing_stop_loss;
        }

        context.emit("buysellData", buysell.value);

        const historyDataResponse = await historyDataSearch(props.symbol);
        marketPrice.value = historyDataResponse.data[0].close;
        closePriceDiff.value =
          historyDataResponse.data[0].close - historyDataResponse.data[1].close;
      } catch (error) {
        console.error(error);
      }
    };

    const getTarget = (data, searchText, target) => {
      return data
        .filter((item) => item.symbol === searchText)
        .map((item) => item[`${target}_target`])[0];
    };

    onMounted(() => {
      getSignal(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      getSignal(newProps.symbol);
    });

    return {
      marketPrice,
      buysell,
      closePriceDiff,
      buyTarget,
      sellTarget,
    };
  },
};
</script>
